export default __webpack_public_path__ + "static/kids-bg-8ecb6028bf062dd144288fc79a0aec7f.jpg";